@if (isLoaded) {
  <app-header></app-header>
  <router-outlet></router-outlet>
  <app-footer class="mt-auto"></app-footer>
}
